@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.reports.z.ui

import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atTime
import kotlinx.datetime.toInstant
import kotlinx.datetime.todayIn
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.api.KtorClient
import us.laantech.routes.pos.reports.z.ZReportDTO
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days

data class ZReportViewState(
    val department: String = "Z Report View",

    val zReport: ZReportDTO? = null,
    val showDatePicker: Boolean = false,

    val reportScopes: List<String> = listOf("This Store", "This POS"),
    val selectedScopeIndex: Int = 0,

    val employeeList : List<EmployeeDTO> = listOf(),
    val selectedEmployeeUUID : String? = null,


    // V2
    val fromDateTime : Long = Clock.System.now().toEpochMilliseconds() - 1.days.inWholeMilliseconds,
    val toDateTime : Long = Clock.System.now().toEpochMilliseconds(),

    val showEndDatePicker: Boolean = false,
    val showStartDatePicker: Boolean = false
) {

}


class ZReportViewModel(): ViewModel() {

    val client = KtorClient.instance.client

    private val _uiState = MutableStateFlow(ZReportViewState())
    val uiState = _uiState.asStateFlow()


    fun selectReportScope(index: Int) {

    }

    suspend fun loadReport() {
        val response = client.get("/backoffice/reports/z") {
            parameter("from_millis", uiState.value.fromDateTime)
            parameter("to_millis", uiState.value.toDateTime)
            parameter("ignore_device_id", uiState.value.selectedScopeIndex)
            parameter("employee_uuid", uiState.value.selectedEmployeeUUID)
        }

        println("ReportsScreenModel Received Z report response: ${response.bodyAsText()}")

        val zReport = response.body<ZReportDTO>()
        _uiState.update { it.copy(zReport = zReport) }
    }




    fun setRange(offset: Long, toOffset: Long = 0L) {
        viewModelScope.launch {

            val tz = TimeZone.currentSystemDefault()
            val today = Clock.System.todayIn(tz)

            val fromDate = LocalDate(today.year, today.month, today.dayOfMonth)
                .let { date ->
                    // subtract offset days
                    val epochDays = date.toEpochDays() - offset.toInt()
                    LocalDate.fromEpochDays(epochDays)
                }
            val toDate = LocalDate(today.year, today.month, today.dayOfMonth)
                .let { date ->
                    val epochDays = date.toEpochDays() - toOffset.toInt()
                    LocalDate.fromEpochDays(epochDays)
                }

            val fromDateTime = fromDate.atTime(0, 0)
            val toDateTime = toDate.atTime(23, 59)

            _uiState.update {
                it.copy(
                    fromDateTime = fromDateTime.toInstant(tz).toEpochMilliseconds(),
                    toDateTime = toDateTime.toInstant(tz).toEpochMilliseconds()
                )
            }

            loadReport()
        }
    }

    fun selectEmployee(uuid: String?) {
        _uiState.update { it.copy(selectedEmployeeUUID = uuid?.ifBlank { null }) }
        viewModelScope.launch {
            loadReport()
        }
    }

    fun loadEmployeeList() {
        viewModelScope.launch {
            val response = client.get("/backoffice/employees/list")
            val employeeList = response.body<List<EmployeeDTO>>()
            _uiState.update { it.copy(employeeList = employeeList) }
        }
    }

    // Show/Hide DatePicker
    fun showStartDatePicker() {
        _uiState.update { it.copy(showStartDatePicker = !it.showStartDatePicker) }
    }

    fun closeStartDatePicker() {
        _uiState.update { it.copy(showStartDatePicker = false) }
    }

    fun showEndDatePicker() {
        _uiState.update { it.copy(showEndDatePicker = !it.showEndDatePicker) }
    }

    fun closeEndDatePicker() {
        _uiState.update { it.copy(showEndDatePicker = false) }
    }

    // Update values from DatePicker
    fun updateFromDateTime(epochMillis: Long) {
        _uiState.update { it.copy(fromDateTime = epochMillis) }
    }

    fun updateToDateTime(epochMillis: Long) {
        _uiState.update { it.copy(toDateTime = epochMillis) }
    }


}